export default class Helper {
  static checkObject(obj) {
    if (!obj) {
      return false
    }
    return obj.constructor === Object && Object.keys(obj).length > 0
  }

  static displayNotification(title, options = {}, data = {}) {
    if (Notification.permission !== 'granted') {
      return false
    }
    console.log(`show ${title} notification`)
    const notify = new Notification(title, {
      requireInteraction: true,
      ...options
    })
    notify.onclick = function () {
      if (typeof data === 'object' && Object.keys(data).length > 0 && data.doc_id) {
        localStorage.setItem('idStaff', data.doc_id)
      }
      window.parent.parent.focus()
      if (data.last_message) {
        localStorage.setItem('lineUserFocusDefault', data.id)
      }
      this.close()
    }
    notify.onshow = function () {
      const self = this
      setTimeout(function() {
        self.close()
      }, 15000)
    }
    return notify
  }

  /**
   * Get content type when request upload file
   * @return {{headers: {"Content-Type": string}}}
   */
  static getContentTypeUpload() {
    return {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  }
}
